import H2 from 'UIComponents/elements/headings/H2';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import { useState } from 'react';
import DebuggerPanelSourceSelectBody from 'automation-ui-canvas/components/panels/debugger-panel/DebuggerPanelSourceSelectBody';
import DebuggerPanelStepBody from 'automation-ui-canvas/components/panels/debugger-panel/DebuggerPanelStepBody';
import { useGetIsUngated } from 'automation-ui-core/hooks/authHooks';
import { getActionHeaderTitle } from 'automation-ui-action-features/records/recordsUtils';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PANEL_WIDTH = 480;
export const SingleActionTestPanel = ({
  flow,
  onClose,
  actionId
}) => {
  const isUngated = useGetIsUngated();
  const [objectId, setObjectId] = useState();
  const getTitle = getActionHeaderTitle({
    flowActions: flow.actions,
    firstActionId: flow.firstActionId,
    isUngated
  });
  const stepName = getTitle({
    actionId
  });
  return /*#__PURE__*/_jsxs(UIPanel, {
    "data-test-id": "single-action-test-panel",
    width: PANEL_WIDTH,
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: stepName ? /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "singleActionTestPanel.headerWithName",
          options: {
            stepName
          }
        }) : /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "singleActionTestPanel.headerNoName"
        })
      })
    }), /*#__PURE__*/_jsx(UIPanelBody, {
      children: /*#__PURE__*/_jsxs(UIPanelSection, {
        style: {
          height: '100%'
        },
        className: "p-all-0 m-all-0",
        children: [/*#__PURE__*/_jsx(DebuggerPanelSourceSelectBody, {
          flowObjectTypeId: flow.getObjectTypeId(),
          onObjectIdSelected: setObjectId,
          objectId: objectId,
          actionId: actionId,
          flow: flow
        }), objectId && /*#__PURE__*/_jsx(DebuggerPanelStepBody, {
          flow: flow,
          objectId: objectId,
          actionId: actionId
        })]
      })
    })]
  });
};
export default SingleActionTestPanel;